<template>
  <div v-if="isRequestEnd" class="free-card-content">
    <div class="top">
      <span>
        {{
          ReplaceText(
            "XXX",
            TLang(cardInfo ? cardInfo.pageTitle : "福利卡", "orderConfirm"),
            TLang("CardTips", "orderConfirm")
          )
        }}
      </span>
      <i
        class="el-input__icon el-icon-arrow-up rotate-180"
        :class="showStatus ? 'is-reverse' : ''"
        @click="changeShow()"
      ></i>
      <span v-if="cardTotal !== '0.00'" class="tip">
        {{ TLang("抵扣", "card")
        }}<span class="red">{{ cardTotal }}</span
        ><span v-if="fppConfigure && fppConfigure.groupItem !== 'Y' || !fppConfigure">{{ cardInfo.name || TLang("福豆", "orderConfirm") }}</span>
        <span v-if="fppConfigure && fppConfigure.groupItem === 'Y' && fppConfigure.groupItemShowRmbSymbol==='Y'">{{TLang("元", "orderConfirm")}}</span> 
        </span
      >
      <span
        v-if="cardInfo && cardInfo.bindCard==='Y'"
        :class="['bandCardBtn',true ? 'floatRight' : '' ]"
        @click="() => {
          sendGio('福利卡', '绑定新卡');
          $emit('bindCard')
        }"
      >
        <span class="iconfont mr-4 hover-rotate-360 font-s20">&#xe65a;</span>
        {{ TLang("绑定新卡", "orderConfirm") }}
      </span>
    </div>
    <div v-show="showStatus" class="bottom">
      <div class="use-select">
        <span
          :class="{ 'use-tab': true, active: type === '0' }"
          @click="
            () => {
              type = '0';
              sendGio('福利卡', '可用卡');
            }
          "
          >{{ TLang("可用", "orderConfirm") }}({{ usableCardsLength }})</span
        >
        <span
          :class="{ 'use-tab': true, 'un-use-tab': true, active: type === '1' }"
          @click="
            () => {
              type = '1';
              sendGio('福利卡', '不可用卡');
            }
          "
          >{{ TLang("不可用", "orderConfirm") }}({{
            unavailableCards.length
          }})</span
        >
      </div>
      <div v-if="type === '0'" class="cardsWrap">
        <template v-if="usableCardsLength > 0">
          <timeCard :interestsInfo="interestsInfo" :sendGio="sendGio" />
          <pointCard :interestsInfo="interestsInfo" :sendGio="sendGio" />
        </template>
        <template v-else>
          <div class="empty-data">
            {{ type === "0" ? TLang("暂无可用福利卡", "orderConfirm") : TLang("暂无不可用福利卡", "orderConfirm") }}
          </div>
        </template>
      </div>
      <div v-else class="cardsWrap">
        <template v-if="unavailableCards.length > 0">
          <unUsedCard :interestsInfo="interestsInfo" :cards="unavailableCards" />
        </template>
        <template v-else>
          <div class="empty-data">
            {{ type === "0" ? TLang("暂无可用福利卡", "orderConfirm") : TLang("暂无不可用福利卡", "orderConfirm") }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import timeCard from "../timeCards";
import pointCard from "../pointCards";
import unUsedCard from "../unUsedCards";
export default {
  name: "FreeCards",
  components: {
    timeCard,
    pointCard,
    unUsedCard,
  },
  props: {
    title: {
      type: String,
      default: window.TLang('使用福利卡抵扣', 'card'),
    },
    fppConfigure: Object,
    // 绑卡
    bindCardHandle: Function,
    // 卡数据
    interestsInfo: Object,
    allSelectCard: Object,
    sendGio: Function,
  },
  data() {
    return {
      showStatus: true,
      type: "0",
    };
  },
  computed: {
    // 卡信息
    cardInfo() {
      if (this.interestsInfo && this.interestsInfo.cardInfo) {
        return this.interestsInfo.cardInfo;
      }
      return {};
    },
    // 可用卡数量
    usableCardsLength() {
      if (this.cardInfo && this.cardInfo.usableNum) {
        return this.cardInfo.usableNum;
      }
      return 0;
    },
    // 不可用卡
    unavailableCards() {
      if (
        this.cardInfo &&
        this.cardInfo.unavailableCardList &&
        this.cardInfo.unavailableCardList.length > 0
      ) {
        return this.cardInfo.unavailableCardList;
      }
      return [];
    },
    isRequestEnd() {
      if (
        Object.prototype.toString.call(this.interestsInfo) === "[object Object]"
      ) {
        return Object.keys(this.interestsInfo).length > 0;
      }
      return false;
    },
    // 福利卡抵扣金额
    cardTotal() {
      if (this.cardInfo && this.cardInfo.usableCardInfo) {
        let total =
          (this.cardInfo.usableCardInfo.totalTimeCardMoney || 0) +
          (this.cardInfo.usableCardInfo.totalPointMoney || 0);
        return Number((total * window.union_scale) / 100).toFixed(2);
      }
      return "0.00";
    },
  },
  created() {
    // 可用卡为0，默认收起
    if (!this.usableCardsLength) {
      this.showStatus = false;
      // 可用卡为0 ，不可用卡不为0，切换至不可用卡上
      if (this.unavailableCards.length) {
        this.type = "1";
      }
    }
  },
  methods: {
    changeShow() {
      this.showStatus = !this.showStatus;
      if (this.showStatus) {
        this.$emit("updateShow");
      }
    },
  },
};
</script>
  <style lang="less" scoped>
.transition {
  -webkit-transition: -webkit-transform 0.3s;
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
}

.rotate(@rotateDegree) {
  color: #111;
  font-size: 22px;
  font-weight: 700;
  -webkit-transform: rotateZ(@rotateDegree);
  transform: rotateZ(@rotateDegree);
  cursor: pointer;
  .transition;
}

.rotate-180 {
  .rotate(180deg);
}
.is-reverse {
  -webkit-transform: rotateZ(0);
  transform: rotateZ(0);
}
.free-card-content {
  padding-top: 24px;
  overflow: hidden;
}
.bandCardBtn {
  margin-left: 32px;
  font-size: 14px;

  color: #333333;
  line-height: 40px;
  font-weight: normal;
  cursor: pointer;
  em {
    margin-right: 5px;
  }
}
.floatRight {
  float: right;
  margin-right: 24px;
}
.top {
  padding-left: 24px;
  font-size: 20px;

  font-weight: bold;
  color: #111111;
  margin-bottom: 14px;
  .tip {
    margin-left: 32px;
    color: #333;
    font-size: 14px;
    font-weight: 400;
    .red {
      color: #f44545;
    }
  }
}
.use-select {
  width: 260px;
  height: 25px;
  margin-left: 24px;
  margin-bottom: 12px;
  .use-tab {
    position: relative;
    font-size: 14px;
  
    color: #333333;
    cursor: pointer;
  }
  .un-use-tab {
    margin-left: 30px;
  }
  .active {
  
    font-weight: bold;
    color: #3d96e2;
  }
  .active:after {
    content: "";
    width: 35px;
    height: 2px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -4px;
    background: linear-gradient(202deg, #5cb4ec 0%, #3d96e2 100%);
    border-radius: 3px;
  }
}
.sel-border {
  border: 2px solid #3d96e2;
}
.noSel-border {
  border: 1px solid #e5e5e5;
}
.empty-data {
  width: 100%;
  height: 60px;
  text-align: center;
  padding-top: 30px;
  font-size: 14px;
  color: #333;
}
</style>

